import { Skeleton } from '@/components/ui/skeleton';
import { TableSkeleton } from './table-skeleton';

/**
 * Default skeleton shown during route transitions.
 * Mimics a typical page layout: title + action buttons + table.
 */
export function PageSkeleton() {
  return (
    <div className="animate-in fade-in duration-300 space-y-4 p-2">
      {/* Page header: title + action buttons */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-48" />
        <div className="flex gap-2">
          <Skeleton className="h-9 w-24 rounded-md" />
          <Skeleton className="h-9 w-24 rounded-md" />
        </div>
      </div>

      {/* Filter bar */}
      <div className="flex gap-2">
        <Skeleton className="h-9 w-64 rounded-md" />
        <Skeleton className="h-9 w-32 rounded-md" />
      </div>

      {/* Table */}
      <TableSkeleton rows={8} columns={5} />
    </div>
  );
}
